import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
interface CountdownProps {
  compact?: boolean;
}
export function Countdown({
  compact = false
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-18" data-mp="10dmwjg0mc75d">
      {!compact && <p className="mb-3 text-center text-xs font-bold uppercase tracking-[0.2em] text-sky-200/80" data-id="element-19" data-mp="15b6aeetemhws">
          This special offer ends in:
        </p>}
      <div className="flex items-stretch justify-center gap-2 sm:gap-3" data-id="element-20" data-mp="xzbz7tiz49lk">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-21" data-mp="szzcd8s3r2iz" data-mpi={index}>
            <div className="flex min-w-[72px] sm:min-w-[88px] flex-col items-center rounded-xl border border-alert/40 bg-navy-900 px-2 py-2.5" data-id="element-22" data-mp="17r9cd5tjlbmx">
              <span className="font-display text-3xl sm:text-4xl leading-none text-white tabular-nums" data-id="element-23" data-mp="12sokbtog1y9k">
                {unit.value}
              </span>
              <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.15em] text-alert" data-id="element-24" data-mp="a40x3sk4wytd">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 && <span className="self-center font-display text-2xl text-alert" aria-hidden="true" data-id="element-25" data-mp="k0c90hftbmna">
                :
              </span>}
          </React.Fragment>)}
      </div>
      <p className="mt-3 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-alert" data-id="element-26" data-mp="1vfit3tbwf977">
        Limited launch pricing available
      </p>
    </div>;
}